import React, { useEffect, useRef, useState } from 'react';
import { getDictationBaseUrl } from '../../../Config/AxiosInstance';
import { ContainerRow, TitleRow, DividerStyle } from '../styledComponents';
import { getCptCodes } from '../../../Apis/Biller';
import {
  HeadingRow,
  ContentRow,
  ActionButton,
  StyledTextArea,
  CustomHeadingCol,
  StyledTabs,
  InfoButton
} from './styledComponents';
import { useSelector } from 'react-redux';
import { MessageOutlined } from '@ant-design/icons';

import {
  Col,
  Dropdown,
  Table,
  Drawer,
  notification,
  Row,
  Collapse,
  Typography,
  Spin,
  Popover,
  Card
} from 'antd';
import { PrinterOutlined } from '@ant-design/icons';

import SessionDetails from '../BillersJobs/SessionDetails';
import { useParams } from 'react-router-dom';
import {
  downloadAudio,
  getDemographics,
  sectionFetch,
  getHeadings,
  deleteSection,
  getInference,
  updateAudioTime,
  updateInference,
  updateInferenceEditFlag,
  forceUpdateJobInference,
  releaseJob,
  getPatientDataSelection,
  editSection
} from '../../../Apis/Jobs';
import { getJobInfoForPrint } from '../../../Apis/Jobs';
import { findPatientMoreDetails } from '../../../Apis/Doctor';
import {
  completeReviewerJob,
  rejectReviewerJob,
  releaseReviewerJob
} from '../../../Apis/Reviewer';
import PageTitle from '../../../Utils/PageTitle';
import CustomTypography from '../../CustomComponents/CustomTypography';
import BreadCrumbComponent from '../../CustomComponents/BreadCrumbComponent';
import CustomAudioPlayer from '../../CustomComponents/AudioPlayer';
import Demographics from './Demographics';
import BillerDemographics from '../Editor/Demographics';

import Spinner from '../../CustomComponents/Spinner';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';
import SuccessModal from '../../CustomComponents/SuccessModal';
import { useHistory, useLocation } from 'react-router-dom';
import ConfirmationIcon from '../../../Assets/Icons/ConfirmationIcon';
import RejectIcon from '../../../Assets/Icons/RejectIcon';
import DeleteIcon from '../../../Assets/Icons/DeleteIcon';
import moment from 'moment';
import BillerJobs from '../BillersJobs';
import {
  formatDate,
  formatTime as formatTimeDisplay,
  formatDateTime,
  getUserTimeZoneConfig
} from '../../../Utils/dateFormat';
import NewEditorComponent from '../../CustomComponents/NewEditorComponent';
import ReleaseJobModal from '../../CustomComponents/ReleaseJobModal';
import MoreHorizIcon from '../../../Assets/Icons/MoreHorizIcon';
import { completeDoctorJob } from '../../../Apis/Doctor';
import { getTokenForUser } from '../../../Apis/Auth';
import FaceSheet from '../BillersJobs/FaceSheet';
import CustomSideDrawer from '../../CustomComponents/CustomSideDrawer';
import { useReactToPrint } from 'react-to-print';
import MipsCompleteModal from './MipsCompleteModal';

import {
  getADTRecord,
  getContacts,
  getCoverages,
  getDataOfPatient,
  getAdvanceDirectivesConsentsData,
  getPractitionersData,
  getAllergyIntoleranceData,
  getPatientObservations,
  getPatientConditions
} from '../../../Apis/Patient';
import {
  getPatientLabReports,
  getPatientMedications,
  getPreviousNotes
} from '../../../Apis/Doctor';
import { AuditInfoContainer } from '../Audit/styledComponents';

const { Panel } = Collapse;
const { Text } = Typography;
const NewEditor = props => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const { jobId } = useParams();
  const audioRef = useRef();
  const [audioUrl, setAudioUrl] = useState(null);
  const [demographicsData, setDemographicsData] = useState([]);
  const [localDemographicsData, setLocalDemographicsData] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sections, setSections] = useState(null);
  const [editedSections, setEditedSections] = useState(null);
  const [headings, setHeadings] = useState(null);
  const [dectationTemplates, setDectationTemplates] = useState([]);
  const [inferenceActive, setInferenceActive] = useState(false);
  const [workType, setWorkType] = useState();
  const [currentTime] = useState(null);
  const [cptCodesLoader, setCptCodesLoader] = useState(false);
  const [paragraphs, setParagraphs] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [ignore, setIgnore] = useState(false);
  const [initIgnore, setinitIgnore] = useState(false);
  const [completeTranscription, setCompleteTranscription] = useState(false);
  const [rejectTranscription, setRejectTranscription] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [highlightWord, setHighlightWord] = useState('');
  const [matchedCodes, setMatchedCodes] = useState([]);
  const editorRef = useRef(null);
  const [cptCodes, setCptCodes] = useState([]);
  const [demographicsLoading, setDemographicsLoading] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [jobCompleted, setJobCompleted] = useState(false);
  const [activeSectionContent, setActiveSectionContent] = useState('');
  const [inferenceData, setInferenceData] = useState([]);
  const [inferenceAnnotation, setInferenceAnnotation] = useState([]);
  const [saveStatus, setSaveStatus] = useState(null);
  const [changeStatus, setChangeStatus] = useState(false);
  const [comments, setComments] = useState([]);
  const [rejectNote, setRejectNote] = useState('');
  const [jobName, setJobName] = useState('');
  const [editorLoading, setEditorLoading] = useState(true);
  const [lastUpdateTime, setLastUpdateTime] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [mipsPrompt, setMipsPrompt] = useState('');
  const [emptySection, setEmptySection] = useState(false);
  const [updateInferenceLoading, setUpdateInferenceLoading] = useState(false);
  const [editorDataPreviewValue] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [userType, setUserType] = useState('');
  const [userType1, setUserType1] = useState('doctor');
  const [viewOnly, setViewOnly] = useState(false);
  const [user] = useSelector(state => [state.userReducer]);
  const [localSectionIdMap] = useState(new Map());
  const [newInferenceActive, setNewInferenceActive] = useState(false);
  const [currentInferenceEngine, setCurrentInferenceEngine] = useState('');
  const [releaseJobId, setReleaseJobId] = useState(null);
  const [releaseJobModalVisible, setReleaseJobModalVisible] = useState(false);
  const [jobStage, setJobStage] = useState('');
  const [refetchDemographics, setRefetchDemographics] = useState(false);
  const [selectionVersion, setSelectionVersion] = useState(0);
  const [patientDataSelection, setPatientDataSelection] = useState(null);
  // Centralized patient data state (fetched once, passed to children)
  const [patientData, setPatientData] = useState({
    vitals: [],
    conditions: [],
    allergies: [],
    labReports: [],
    medications: [],
    progressNotes: [],
    loaded: false
  });
  const patientDataFetchedRef = useRef(false);
  const [userRoles, setUserRoles] = useState([]);
  const [openTab, setOpenTab] = useState('patientdetails');
  const [openTab1, setOpenTab1] = useState(false);
  const [tabDataPatient, setTabDataPatient] = useState({});
  const [printInfoData, setPrintInfoData] = useState([]);
  const [printMoreData, setPrintmoreData] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerType, setDrawerType] = useState(null); // "details" or "faceSheet"
  // undefined = demographics not yet fetched; null = fetched but no date; string = date value
  const [dateOfVisit, setDateOfVisit] = useState(undefined);

  const menuItems = [
    {
      key: 'details',
      label: 'Patient Details',
      onClick: () => {
        setDrawerType('details');
        setShowDrawer(true);
      }
    },
    {
      key: 'faceSheet',
      label: 'Face Sheet',
      onClick: () => {
        setDrawerType('faceSheet');
        setShowDrawer(true);
      }
    }
  ];
  const noteRef = useRef();

  // 🖨️ Print function using react-to-print
  const handlePrintNote = useReactToPrint({
    content: () => noteRef.current,
    documentTitle: 'Note Content'
  });
  const diagnosisData = props.printMoreData || [];
  const diagnosisPairs = [];
  const loginMethod = sessionStorage.getItem('loginMethod');
  const accessToken = localStorage.getItem('accessToken');
  const diagnoses = (tabDataPatient?.Diagnosisinfo?.medDiagonsis || []).map(
    diagnosis => {
      const onset = diagnosis.onsetDate
        ? formatDate(diagnosis.onsetDate)
        : 'N/A';

      const desc = diagnosis.icd10Description || '-';
      const shortDesc = desc.length > 30 ? desc.slice(0, 30) + '...' : desc;

      const code = diagnosis.icd10 || '-';

      return `${onset} - ${shortDesc} (${code})`;
    }
  );

  useEffect(() => {
    const nodes =
      paragraphs && paragraphs.length > 0
        ? paragraphs
        : document.querySelectorAll('.paragraph');

    if (
      !matchedCodes ||
      matchedCodes.length === 0 ||
      nodes.length === 0 ||
      initIgnore
    )
      return;

    const pattern = matchedCodes
      .map(item => item?.cptCode)
      .filter(code => code != null)
      .map(code => String(code).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|');

    if (!pattern) return; // avoid empty regex

    const regex = new RegExp(`(${pattern})`, 'gi');

    nodes.forEach(node => {
      const text = node.innerText || '';

      const highlightedText = text.replace(
        regex,
        `<span style="background-color: yellow;">$1</span>`
      );

      node.innerHTML = highlightedText;
    });
    setIgnore(false);
    setinitIgnore(true);
  }, [ignore, document.querySelectorAll('.paragraph')]);

  useEffect(() => {
    if (sections && sections.length > 0) {
      const stripHtml = html => html.replace(/<[^>]*>/g, ' ');
      const contentSource =
        editedSections && editedSections.length > 0 ? editedSections : sections;

      const content = contentSource
        .map(sec => {
          if (Array.isArray(sec.content)) {
            return sec.content
              .map(c => stripHtml(c.value || '').toLowerCase())
              .join(' ');
          } else {
            return stripHtml(sec.content || '').toLowerCase();
          }
        })
        .join(' ');

      const foundCodes = cptCodes.filter(item =>
        content.toLowerCase().includes(item.cptCode.toLowerCase())
      );

      setMatchedCodes(foundCodes);
    }
  }, [sections, cptCodes]);
  // Group into pairs of two
  for (let i = 0; i < diagnoses.length; i += 2) {
    diagnosisPairs.push(diagnoses.slice(i, i + 2));
  }

  useEffect(() => {
    getCptCodes(jobId)
      .then(response => {
        if (response.data.success) {
          const codes = response.data.result.map(item => ({
            cptCode: item.cptCode,
            description: item.description,
            category: item.category,
            content: item.content
          }));

          setCptCodes(codes);
        } else {
          notification['error']({
            message: 'CPT Codes Fetch Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log('Error fetching CPT codes:', err);
      });
  }, []);
  const contactRows = (tabDataPatient?.contacts?.[0]?.data || []).map(
    contacts => {
      const fullName = [
        contacts.lastName,
        contacts.firstName ? `, ${contacts.firstName}` : ''
      ]
        .filter(Boolean)
        .join('');

      const contactTypes = (contacts.type || [])
        .map(t => t.contactType)
        .join(', ');

      const phoneOrEmail =
        contacts.cellPhone ||
        contacts.homePhone ||
        contacts.officePhone ||
        contacts.email ||
        'N/A';

      const address = [
        contacts.addressLine1,
        contacts.addressLine2,
        contacts.city
      ]
        .filter(Boolean)
        .join(', ');

      return {
        name: fullName || 'N/A',
        types: contactTypes || 'N/A',
        relationship: contacts.relationship || 'N/A',
        address: address || 'N/A',
        contactInfo: phoneOrEmail
      };
    }
  );
  const advanceRows = (tabDataPatient?.adtrecords?.[0]?.data || []).map(
    item => ({
      actionType: item.actionType || 'N/A',
      effectiveDateTime: item.effectiveDateTime || 'N/A',
      bedId: item.bedId || 'N/A',
      payerCode: item.payerCode || 'N/A',
      payerName: item.payerName || 'N/A'
    })
  );
  const practionersList = (tabDataPatient?.practioners?.[0]?.data || []).map(
    p => ({
      name: [p.lastName, p.firstName].filter(Boolean).join(', '),
      relation: p.relation,
      address: [p.addressLine1, p.addressLine2, p.city]
        .filter(Boolean)
        .join(', '),
      country: p.country || 'N/A',
      providerType: p.providerType || 'N/A'
    })
  );
  const allergyList = (tabDataPatient?.allergy?.[0]?.data || []).map(item => ({
    allergen: item.allergen || 'N/A',
    allergyIntoleranceId: item.allergyIntoleranceId || 'N/A',
    category: item.category || 'N/A',
    severity: item.severity || 'N/A',
    type: item.type || 'N/A'
  }));
  const diagnosisList = (tabDataPatient?.medDiagonsis || []).map(d => ({
    date: d.onsetDate
      ? formatDate(d.onsetDate)
      : 'N/A',
    description:
      d.icd10Description?.length > 40
        ? d.icd10Description.slice(0, 40) + '...'
        : d.icd10Description || '—',
    icd: d.icd10 || '—'
  }));

  const consentsList = (tabDataPatient?.consents?.[0]?.data || []).map(
    item => ({
      consentStatus: item.consentStatus || 'N/A',
      description: item.description || 'N/A',
      orderedBy: item.orderedBy || 'N/A'
    })
  );
  const tabList = [
    { val: 'Patient Details', key: 'patientdetails' },
    { val: 'Coverages', key: 'coverages' },

    { val: 'Diagnosis Info', key: 'Diagnosisinfo' },
    { val: 'Contacts', key: 'contacts' },
    { val: 'Allergy', key: 'allergy' },
    { val: 'Practioners', key: 'practioners' },

    { val: 'Consents', key: 'consents' },
    { val: 'ADT Records', key: 'adtrecords' }
  ];
  const getPageMargins = () => {
    return `
 @media print {
      @page {
        margin: 2cm 1.5cm;
      }

      body {
        counter-reset: page;
      }

      .page::after {
        counter-increment: page;
        content: "Page " counter(page);
        position: fixed;
        bottom: 1cm;
        right: 1.5cm;
        font-size: 12px;
        color: #444;
      }

      .custom-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        padding-top: 10px;
      }

      .content {
        margin-top: 60px; /* pushes content below fixed header */
      }
    }
    `;
  };
  const apiFunctions = {
    // patientdetails, coverages, practioners are fetched upfront in centralized fetch
    Diagnosisinfo: findPatientMoreDetails,

    contacts: getContacts,
    allergy: getAllergyIntoleranceData,

    consents: getAdvanceDirectivesConsentsData,
    adtrecords: getADTRecord
  };
  const fetchTabData = async () => {
    const apiCall = apiFunctions[openTab];

    if (!apiCall) return; // No API defined yet for this tab
    if (!printInfoData[0]) return;

    // Skip patient-related tab APIs for non doctor+in-progress routes
    const searchParams = new URLSearchParams(window.location.search);
    const currentJobStage = searchParams.get('jobStage');
    const currentUserRole = searchParams.get('userRole');
    if (currentJobStage === 'in-review' || currentJobStage === 'completed' || currentJobStage === 'incomplete' || currentJobStage === 'ready' || currentUserRole === 'reviewer') return;

    const facilityId = printInfoData[0]?.facility.facilityId;
    const patientId = printInfoData[0]?.patientId;
    setLoading(true);

    apiCall(facilityId, patientId)
      .then(response => {
        if (response.data.success === true) {
          setTabDataPatient(prev => ({
            ...prev,
            [openTab]: response.data.result
          }));
        } else {
          notification['error']({
            message: 'Fetch Failed',
            description: response.data.message
          });
        }

        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.error(err);
        notification['error']({
          message: 'API Error',
          description: 'Something went wrong while fetching data.'
        });
      });
  };

  useEffect(() => {
    fetchTabData();
  }, [openTab, printInfoData]);
  const getUserRole = () => {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.scopes || null;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };

  useEffect(() => {
    const role = getUserRole();
    setUserRoles(role);
    getJobInfoForPrint(jobId)
      .then(response => {
        if (response.data.success === true) {
          const job = response.data.result?.[0] || {};
          setPrintInfoData(response.data.result);
          setComments(job.comments || []);
        } else {
          notification['error']({
            message: 'Fetch Failed',
            description: response.data.message
          });
        }
        // setDemographicsLoading(false);
        // setRefetchDemographics(false);
      })
      .catch(err => {
        // setDemographicsLoading(false);
        // setRefetchDemographics(false);
        console.log(err);
        // setDemographicsLoading(false);
      });
  }, []);

  // Centralized patient data fetching - called once when printInfoData is available
  useEffect(() => {
    if (!printInfoData || !printInfoData[0]) return;
    if (patientDataFetchedRef.current) return; // Prevent duplicate fetches

    const facilityId = printInfoData[0]?.facility?.facilityId;
    const patientId = printInfoData[0]?.patientId;

    if (!facilityId || !patientId) return;

    patientDataFetchedRef.current = true;

    const fetchAllPatientData = async () => {
      try {
        const searchParams = new URLSearchParams(window.location.search);
        const currentJobStage = searchParams.get('jobStage');

        // Skip all patient data APIs for non doctor+in-progress routes
        const currentUserRole = searchParams.get('userRole');
        if (currentJobStage === 'in-review' || currentJobStage === 'completed' || currentJobStage === 'incomplete' || currentJobStage === 'ready' || currentUserRole === 'reviewer') {
          setPatientData(prev => ({ ...prev, loaded: true }));
          return;
        }

        // Only fetch lab reports, medications, and previous notes for doctor/scribe + in-progress
        const isDoctorInProgress =
          currentJobStage === 'in-progress' &&
          (searchParams.get('userRole') === 'doctor' || searchParams.get('userRole') === 'scribe');

        const [
          observationsRes,
          conditionsRes,
          allergiesRes,
          labReportsRes,
          medicationsRes,
          progressNotesRes,
          patientDetailsRes,
          practitionersRes
        ] = await Promise.allSettled([
          getPatientObservations(facilityId, patientId),
          getPatientConditions(facilityId, patientId),
          getAllergyIntoleranceData(facilityId, patientId),
          isDoctorInProgress ? getPatientLabReports(facilityId, patientId) : Promise.resolve(null),
          isDoctorInProgress ? getPatientMedications(facilityId, patientId) : Promise.resolve(null),
          isDoctorInProgress ? getPreviousNotes(patientId, facilityId, 0, 10) : Promise.resolve(null),
          getDataOfPatient(facilityId, patientId),
          getPractitionersData(facilityId, patientId)
        ]);

        // Process vitals/observations (API returns { result: [{ date, data: [...] }] })
        let vitals = [];
        if (observationsRes.status === 'fulfilled' && observationsRes.value?.data?.success) {
          vitals = observationsRes.value.data.result?.flatMap(item =>
            item.data?.map((obs, index) => ({
              key: `${item.date}-${index}`,
              type: obs.type ? obs.type.charAt(0).toUpperCase() + obs.type.slice(1).replace(/([A-Z])/g, ' $1').trim() : 'N/A',
              value: obs.value || 'N/A',
              unit: obs.unit || '',
              date: item.date || 'N/A',
              recordedDate: obs.recordedDate,
              recordedAt: obs.recordedAt || obs.recordedTime,
              selected: false,
              raw: obs
            })) || []
          ) || [];
        }

        // Process conditions (API returns { result: [{ data: [{ conditionCode: { codings: [...] } }] }] })
        let conditions = [];
        if (conditionsRes.status === 'fulfilled' && conditionsRes.value?.data?.success) {
          const conditionData = conditionsRes.value.data.result || [];
          conditionData.forEach(item => {
            if (item.data && Array.isArray(item.data)) {
              item.data.forEach((condition, condIndex) => {
                const firstCoding = condition.conditionCode?.codings?.[0];
                conditions.push({
                  key: `${condIndex}-${condition.conditionId || firstCoding?.code}`,
                  code: firstCoding?.code,
                  display: condition.icd10Description || firstCoding?.display,
                  system: firstCoding?.system,
                  version: firstCoding?.version,
                  icd10: condition.icd10,
                  icd10Description: condition.icd10Description,
                  clinicalStatus: condition.clinicalStatus,
                  selected: false,
                  raw: condition
                });
              });
            }
          });
        }

        // Process allergies (API returns { result: [{ data: [...] }] })
        let allergies = [];
        if (allergiesRes.status === 'fulfilled' && allergiesRes.value?.data?.success) {
          const allergyData = allergiesRes.value.data.result?.flatMap(item => item.data || []) || [];
          allergies = allergyData.map((allergy, index) => ({
            key: index.toString(),
            allergen: allergy.allergen,
            allergyIntoleranceId: allergy.allergyIntoleranceId,
            category: allergy.category,
            severity: allergy.severity,
            type: allergy.type,
            selected: false,
            raw: allergy
          }));
        }

        // Process lab reports (API returns { result: [{ data: [...] }] })
        let labReports = [];
        if (labReportsRes.status === 'fulfilled' && labReportsRes.value?.data?.success) {
          const labData = labReportsRes.value.data.result?.flatMap(item => item.data || []) || [];
          labReports = labData.map((report, index) => ({
            key: index.toString(),
            reportId: report.reportId,
            reportingLaboratory: report.reportingLaboratory,
            performingLaboratory: report.performingLaboratory,
            effectiveDateTime: report.effectiveDateTime,
            issuedDateTime: report.issuedDateTime,
            testSet: report.testSet,
            selected: false,
            raw: report
          }));
        }

        // Process medications (API returns { result: [{ data: [...] }] })
        let medications = [];
        if (medicationsRes.status === 'fulfilled' && medicationsRes.value?.data?.success) {
          const medData = medicationsRes.value.data.result?.flatMap(item => item.data || []) || [];
          medications = medData.map((med, index) => ({
            key: index.toString(),
            orderId: med.orderId,
            description: med.description,
            strength: med.strength,
            strengthUOM: med.strengthUOM,
            directions: med.directions,
            startDate: med.startDate,
            schedules: med.schedules,
            selected: false,
            raw: med
          }));
        }

        // Process progress notes (API returns { result: [{ data: [...] }] })
        let progressNotes = [];
        if (progressNotesRes.status === 'fulfilled' && progressNotesRes.value?.data?.success) {
          const notesData = progressNotesRes.value.data.result?.flatMap(item => item.data || []) || [];
          progressNotes = notesData.map((note, index) => ({
            key: index.toString(),
            progressNoteId: note.progressNoteId,
            effectiveDate: note.effectiveDate,
            createdDate: note.createdDate,
            createdBy: note.createdBy,
            progressNoteType: note.progressNoteType,
            jobId: note.jobForProgressNote?.jobId,
            sectionObjects: note.jobForProgressNote?.sectionObjects || [],
            selected: false,
            raw: note
          }));
        }

        // Store patient details, coverages, and practitioners in tabDataPatient
        // so they're available for K2P demographic placeholders
        if (patientDetailsRes.status === 'fulfilled' && patientDetailsRes.value?.data?.success) {
          setTabDataPatient(prev => ({
            ...prev,
            patientdetails: patientDetailsRes.value.data.result
          }));
        }
        if (
          practitionersRes.status === 'fulfilled' &&
          practitionersRes.value?.data?.success
        ) {
          setTabDataPatient(prev => ({
            ...prev,
            practioners: practitionersRes.value.data.result
          }));
        }

        setPatientData({
          vitals,
          conditions,
          allergies,
          labReports,
          medications,
          progressNotes,
          loaded: true
        });

        // Also fetch patient data selection (only once)
        if (!patientDataSelection) {
          getPatientDataSelection(jobId)
            .then(res => {
              if (res.data?.result?.[0]) {
                setPatientDataSelection(res.data.result[0]);
              } else {
                // Set empty object to indicate fetch complete with no data
                setPatientDataSelection({});
              }
            })
            .catch(err => {
              console.error('Error fetching patient data selection:', err);
              // Set empty object to indicate fetch complete (with error)
              setPatientDataSelection({});
            });
        }
      } catch (err) {
        console.error('Error fetching patient data:', err);
        setPatientData(prev => ({ ...prev, loaded: true }));
      }
    };

    fetchAllPatientData();
  }, [printInfoData]);

  // Fetch coverages once both printInfoData and dateOfVisit (from demographics) are ready
  useEffect(() => {
    if (!printInfoData?.[0]) return;
    if (dateOfVisit === undefined) return; // Wait for demographics API to complete

    const searchParams = new URLSearchParams(window.location.search);
    const currentJobStage = searchParams.get('jobStage');
    const currentUserRole = searchParams.get('userRole');
    if (
      currentJobStage === 'in-review' ||
      currentJobStage === 'completed' ||
      currentJobStage === 'incomplete' ||
      currentJobStage === 'ready' ||
      currentUserRole === 'reviewer'
    )
      return;

    const facilityId = printInfoData[0]?.facility?.facilityId;
    const patientId = printInfoData[0]?.patientId;
    if (!facilityId || !patientId) return;

    getCoverages(facilityId, patientId, dateOfVisit)
      .then(response => {
        if (response?.data?.success) {
          setTabDataPatient(prev => ({
            ...prev,
            coverages: response.data.result
          }));
        }
      })
      .catch(err => console.error('Error fetching coverages:', err));
  }, [printInfoData, dateOfVisit]);

  const refetchPatientTabData = () => {
    if (!printInfoData || !printInfoData[0]) return;
    const searchParams = new URLSearchParams(window.location.search);
    const currentJobStage = searchParams.get('jobStage');
    const currentUserRole = searchParams.get('userRole');
    if (currentJobStage === 'in-review' || currentJobStage === 'completed' || currentJobStage === 'incomplete' || currentJobStage === 'ready' || currentUserRole === 'reviewer') return;
    const facilityId = printInfoData[0]?.facility?.facilityId;
    const patientId = printInfoData[0]?.patientId;
    if (!facilityId || !patientId) return;

    Promise.allSettled([
      getDataOfPatient(facilityId, patientId),
      getCoverages(facilityId, patientId, dateOfVisit)
    ]).then(([patientDetailsRes, coveragesRes]) => {
      if (patientDetailsRes.status === 'fulfilled' && patientDetailsRes.value?.data?.success) {
        setTabDataPatient(prev => ({
          ...prev,
          patientdetails: patientDetailsRes.value.data.result
        }));
      }
      if (coveragesRes.status === 'fulfilled' && coveragesRes.value?.data?.success) {
        setTabDataPatient(prev => ({
          ...prev,
          coverages: coveragesRes.value.data.result
        }));
      }
    });
  };

  useEffect(() => {
    if (changeStatus === true || saveStatus === 'Saving') {
      window.addEventListener('beforeunload', keepOnPage);
      return () => window.removeEventListener('beforeunload', keepOnPage);
    }
    // eslint-disable-next-line
  }, [saveStatus, changeStatus]);
  useEffect(() => {
    getDemographicsData();
  }, [localDemographicsData]);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setUserType(searchParams.get('userRole'));
    setJobStage(searchParams.get('jobStage'));

    setViewOnly(
      searchParams.get('jobStage') &&
        (searchParams.get('jobStage') === 'ready' ||
        searchParams.get('jobStage') === 'in-progress'
          ? false
          : true)
    );
    // setViewOnly(userType === 'doctor' ? false : true);

    setDemographicsLoading(true);
    getDemographics(jobId)
      .then(response => {
        if (response.data.success === true) {
          setLocalDemographicsData(response.data.result);
          const visitDateItem = response.data.result?.find(
            item => item.key === 'DATE OF VISIT'
          );
          setDateOfVisit(visitDateItem?.value ?? null);
          setDemographicsLoading(false);
        } else {
          notification['error']({
            message: 'Demographics Fetch Failed',
            description: response.data.message
          });
          setDateOfVisit(null);
          setDemographicsLoading(false);
        }
        setRefetchDemographics(false);
      })
      .catch(err => {
        console.log(err);
        setDateOfVisit(null);
        setDemographicsLoading(false);
      });

    // eslint-disable-next-line
  }, [refetchDemographics]);

  useEffect(() => {
    fetchContents(activeSection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);
  useEffect(() => {
    fetchContents(activeSection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const keepOnPage = event => {
    var message =
      "Warning!\n\nNavigating away from this page will delete your text if you haven't already saved it.";
    event.returnValue = message;
    return message;
  };

  const getAudio = () => {
    setLoading(true);
    downloadAudio(jobId)
      .then(response => {
        if (response.data.success === true) {
          getEditorData();
          setAudioUrl(response.data.result[0]);
          setLoading(false);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
          setLoading(false);
        }
      })
      .catch(err => {
        setLoading(false);
        console.log(err);
      });
  };

  const getDemographicsData = () => {
    setDemographicsData(localDemographicsData);
  };

  const updateEncounterDate = (newDate) => {
    const updater = prev => prev.map(item =>
      item.key === 'DATE OF VISIT' ? { ...item, value: newDate } : item
    );
    setLocalDemographicsData(updater);
    setDemographicsData(updater);
  };

  const getInferenceData = async sectionId => {
    if (currentInferenceEngine !== (newInferenceActive ? 'new' : 'old')) {
      await forceUpdateInferencedata();
    }
    setCurrentInferenceEngine(newInferenceActive ? 'new' : 'old');
    setDemographicsLoading(true);
    getInference(jobId, sectionId, newInferenceActive)
      .then(response => {
        if (response.data.success === true) {
          setInferenceData(response.data.result);
          setDemographicsLoading(false);
        } else {
          notification['error']({
            message: 'Inference Fetch Failed',
            description: response.data.message
          });
          setDemographicsLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setDemographicsLoading(false);
      });
  };
  const patientFieldMap = [
    {
      label: 'ResidentName',
      path: `${tabDataPatient?.patientdetails?.[0]?.prefix || ''} ${
        tabDataPatient?.patientdetails?.[0]?.lastName
          ? tabDataPatient.patientdetails[0].lastName + ','
          : ''
      } ${tabDataPatient?.patientdetails?.[0]?.firstName || ''} ${
        tabDataPatient?.patientdetails?.[0]?.middleName
          ? tabDataPatient.patientdetails[0].middleName[0] + '.'
          : ''
      }`.trim()
    },
    {
      label: 'Preferred Name',
      path: tabDataPatient?.patientdetails?.[0]?.preferredName
    },
    { label: 'Unit', path: tabDataPatient?.patientdetails?.[0]?.unitDesc },
    {
      label: 'Room/Bed',
      path: `${tabDataPatient?.patientdetails?.[0]?.bedId || localDemographicsData?.find(d => d?.key === 'bedId')?.value || ''}${
        tabDataPatient?.patientdetails?.[0]?.bedDesc
          ? '-' + tabDataPatient.patientdetails[0].bedDesc
          : ''
      }`
    },
    {
      label: 'Admission Date',
      path: (() => {
        const dateStr =
          tabDataPatient?.patientdetails?.[0]?.admissionDate ||
          localDemographicsData?.find(d => d?.key === 'admissionDate')?.value;
        return dateStr ? formatDate(dateStr) : '';
      })()
    },
    { label: 'Sex', path: tabDataPatient?.patientdetails?.[0]?.gender },
    {
      label: 'Birthdate',
      path: tabDataPatient?.patientdetails?.[0]?.birthDate
        ? formatDate(tabDataPatient.patientdetails[0].birthDate)
        : ''
    },
    { label: 'Religion', path: tabDataPatient?.patientdetails?.[0]?.religion }
  ];

  const diaganosisinfoMap = (
    tabDataPatient?.Diagnosisinfo?.medDiagonsis || []
  ).map(diagnosis => {
    const onset = diagnosis.onsetDate
      ? formatDate(diagnosis.onsetDate)
      : 'N/A';

    const desc = diagnosis.icd10Description || '-';
    const shortDesc = desc.length > 40 ? desc.slice(0, 40) + '...' : desc;

    const code = diagnosis.icd10 || '-';

    return {
      displayText: `${onset} - ${shortDesc} (${code})`
    };
  });

  const coverageData = [
    {
      label: 'Primary Payer',
      path:
        tabDataPatient?.coverages?.[0]?.payers?.find(
          p => p.payerRank === 'Primary'
        )?.payerName || ''
    },
    {
      label: 'Second Payer',
      path:
        tabDataPatient?.coverages?.[0]?.payers?.find(
          p => p.payerRank === 'Secondary'
        )?.payerName || ''
    },
    {
      label: 'Third Payer',
      path:
        tabDataPatient?.coverages?.[0]?.payers?.find(
          p => p.payerRank === 'Third'
        )?.payerName || ''
    },
    {
      label: 'Fourth Payer',
      path:
        tabDataPatient?.coverages?.[0]?.payers?.find(
          p => p.payerRank === 'Fourth'
        )?.payerName || ''
    },
    {
      label: 'Group',
      path:
        tabDataPatient?.coverages?.[0]?.payers?.[0]?.issuer?.[0]?.group || ''
    },
    {
      label: 'Ins. Company',
      path:
        tabDataPatient?.coverages?.[0]?.payers?.[0]?.issuer?.issuerName || ''
    },
    {
      label: 'Medicaid',
      path:
        tabDataPatient?.coverages?.[0]?.payers?.[0]?.issuer?.planNumber || ''
    }
  ];

  const consentsData = [
    {
      label: 'Consent Status',
      path: tabDataPatient?.consents?.[0]?.data?.[0]?.consentStatus
    },
    {
      label: 'Description',
      path: tabDataPatient?.consents?.[0]?.data?.[0]?.description
    },
    {
      label: 'ordered By',
      path: tabDataPatient?.consents?.[0]?.data?.[0]?.orderedBy
    }
  ];

  const contactData = [
    {
      label: 'Name',
      path: tabDataPatient?.contact?.[0]?.data?.[0]?.firstName
    },

    {
      label: 'Address',
      path: tabDataPatient?.contact?.[0]?.data?.[0]?.addressLine1
    },
    {
      label: 'Relationship',
      path: tabDataPatient?.contact?.[0]?.data?.[0]?.relationship
    },
    {
      label: 'contactNumber',
      path: tabDataPatient?.contact?.[0]?.data?.[0]?.contactNumber
    }
  ];
  const forceUpdateInferencedata = async () => {
    await forceUpdateJobInference(jobId);
  };

  const updateInferenceData = payload => {
    updateInference(jobId, activeSection, payload).then(response => {
      if (response.data.success) {
        fetchContents(activeSection);
      } else {
        notification['error']({
          message: 'Inference Update Failed',
          description: response.data.message
        });
      }
      setUpdateInferenceLoading(false);
    });
  };

  const updateInferenceFlag = (payload, isFromTable) => {
    updateInferenceEditFlag(jobId, activeSection, payload)
      .then(response => {
        if (response.data.success) {
          !isFromTable && fetchContents(activeSection);
          setUpdateInferenceLoading(false);
        } else {
          notification['error']({
            message: 'Edit Flag Update Failed',
            description: response.data.message
          });
          setUpdateInferenceLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setUpdateInferenceLoading(false);
      });
  };

  const fetchContents = (activeSection, fromSave) => {
    if (inferenceActive || fromSave) {
      if (activeSection && !activeSection.includes('new')) {
        if (activeSectionContent?.value?.trim().length === 0) {
          setEmptySection(true);
          getDemographicsData();
        } else {
          getInferenceData(activeSection);
          setEmptySection(false);
        }
      }
    } else if (!inferenceActive && !fromSave) {
      getDemographicsData();
    }
  };

  const formatTime = time => {
    const savedTime = moment(time);
    const now = moment(new Date());
    const diff = now.diff(savedTime, 'hours');

    if (diff > 12) {
      return formatDateTime(savedTime);
    } else {
      return 'Today ' + formatTimeDisplay(savedTime);
    }
  };
  function processValue(value) {
    let content = value;

    // Split by <br> tags and wrap each part in <p> tags (this format works!)
    const parts = content.split(/<br\s*\/?>/gi);

    if (parts.length > 1) {
      // Convert br tags to separate paragraphs
      content = parts
        .map(part => {
          part = part.trim();
          // Remove existing <p> tags to avoid nesting
          part = part.replace(/<\/?p>/gi, '');
          // Return as paragraph
          return part ? `<p>${part}</p>` : '<p><br></p>';
        })
        .join('');
    }

    return content;
  }
  const getEditorData = () => {
    setEditorLoading(true);
    sectionFetch(jobId)
      .then(response => {
        if (response.data.success) {
          for (let i = 0; i < response.data.result.length; i++) {
            const resultItem = response.data.result[i];
            for (let j = 0; j < resultItem.sections.length; j++) {
              const section = resultItem.sections[j];
              for (let k = 0; k < section.content.length; k++) {
                const contentItem = section.content[k];
                if (contentItem.type === 'Text') {
                  response.data.result[i].sections[j].content[k].value =
                    processValue(contentItem.value);
                }
              }
            }
          }

          setSections(
            response.data.result[0] && response.data.result[0].sections
          );

          setDectationTemplates(response.data.templates);
          setActiveSection(
            response.data.result[0].sections &&
              response.data.result[0].sections.length > 0 &&
              response.data.result[0].sections[0].id
          );
          setJobName(response.data.jobName);
          setMipsPrompt(response.data.mipsPrompt || '');
          setLastUpdateTime(response.data.result[0].lastUpdatedTime);
          setEditorLoading(false);
        } else {
          notification['error']({
            message: 'Section Fetch Failed',
            description: response.data.message
          });
          setEditorLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setEditorLoading(false);
      });
    getHeadings(jobId)
      .then(response => {
        if (response.data.success === true) {
          setHeadings(response.data.result);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (jobId) {
      getAudio();
      getDemographicsData();
    }
    // eslint-disable-next-line
  }, [jobId]);

  useEffect(() => {
    if (jobId) {
      fetchContents(activeSection);
    }
    // eslint-disable-next-line
  }, [selectedSection, inferenceActive, newInferenceActive]);

  useEffect(() => {
    if (currentTime) {
      if (audioRef.current && audioRef.current.audio.current) {
        audioRef.current.audio.current.currentTime = currentTime;
      }
    }
  }, [currentTime, audioRef]);

  const deleteSectionHandler = sectionId => {
    setSelectedSection(sectionId);
    // setConfirmationModal(true);
  };
  const deleteSectionFromEditor = selectedId => {
    setSections(prev => prev.filter(item => item.id !== selectedId));
    setDeleteModalVisible(false);
  };

  const deleteConfirmationHandler = () => {
    let sectionIdToDelete = selectedSection;
    setConfirmLoading(true);
    if (selectedSection.includes('new')) {
      if (!localSectionIdMap.get(selectedSection)) {
        notification['error']({
          message: 'Failed',
          description: `Unable to process please try again after some time.`
        });
        setConfirmLoading(false);
        return;
      }
      sectionIdToDelete = localSectionIdMap.get(selectedSection);
      // setConfirmationModal(false);
    }
    deleteSection(jobId, sectionIdToDelete)
      .then(response => {
        setConfirmLoading(false);
        if (response.data.success === true) {
          setActiveSection(null);
          setInferenceActive(false);
          getEditorData();
          setConfirmationModal(false);
          setSuccessModal(true);
          setSelectedSection(null);
        } else {
          setConfirmLoading(false);
          getEditorData();
        }
      })
      .catch(err => {
        console.log(err);
        notification['error']({
          message: 'Failed',
          description: err
        });
        setConfirmLoading(false);
      });
  };

  const deleteCancelHandler = () => {
    setConfirmationModal(false);
    setCompleteTranscription(false);
    setRejectTranscription(false);
    setSelectedSection(null);
  };

  let BreadCrumbItems = [
    ...(user?.userType !== 'scribe' ? [{ name: 'Dashboard', path: '/dashboard' }] : []),
    {
      name: 'Jobs-list',
      path: `/dashboard/jobs-list/${jobStage}`
    },
    {
      name: userType === 'doctor' ? 'my-jobs' : 'jobs-to-review',
      path: `/dashboard/jobs-list/${
        userType === 'doctor' ? 'my-jobs' : 'jobs-to-review'
      }/${jobStage}?fromEditor=true`
    },
    {
      name: userType === 'doctor' ? 'Job Editor' : 'Job Review'
    },
    {
      name: `${jobName}`
    }
  ];

  const handleScribeSubmit = () => {
    if (jobStage === 'completed') return;
    const currentData =
      typeof editorRef.current?.getCurrentData === 'function'
        ? editorRef.current.getCurrentData()
        : null;
    if (!currentData) return;
    const payload = {
      sections: currentData,
      sectionIds: currentData.map(s => s.id)
    };
    editSection(jobId, payload, user.sessionId)
      .then(response => {
        if (response.data.success) {
          history.push('/dashboard/jobs-list/my-jobs/in-progress');
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.error(err);
        notification['error']({
          message: 'Error',
          description: 'Failed to save. Please try again.'
        });
      });
  };

  const confirmCompleteOrApprove = () => {
    if (!workType) {
      notification.warning({
        message: 'Missing Work Type',
        description: 'Please select a work type before continuing.',
        placement: 'topRight' // you can change position
      });
      return;
    }
    const dateOfVisitEntry = demographicsData?.find(
      item => item.key === 'DATE OF VISIT'
    );
    if (
      dateOfVisitEntry?.value &&
      moment(dateOfVisitEntry.value).isAfter(moment())
    ) {
      notification.warning({
        message: 'Future date/time is not allowed for Date of Encounter'
      });
      return;
    }
    setCompleteTranscription(true);
  };

  const confirmRejectorAssignBack = () => {
    setRejectTranscription(true);
  };

  const audioUpdate = audioTime => {
    if (audioTime !== 0) {
      updateAudioTime(jobId, audioTime)
        .then(response => {
          if (!response.data.success) {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };


  const completeOrApprove = () => {
    setConfirmLoading(true);
    // Get the current editor data directly from the editor ref to ensure we have the latest changes
    const currentEditorData = typeof editorRef.current?.getCurrentData === 'function'
      ? editorRef.current.getCurrentData()
      : null;
    const sectionsData = currentEditorData || editedSections || sections;
    console.log('completeOrApprove called:', {
      userType,
      jobId,
      sessionId: user?.sessionId
    });
    (userType === 'doctor' ||
      userType === 'clinicAdmin' ||
      userType === 'admin') &&
      completeDoctorJob(jobId, user.sessionId, sectionsData, getUserTimeZoneConfig())
        .then(response => {
          if (response.data.success) {
            setJobCompleted(true);
            setConfirmLoading(false);
            const redirectToJobsList = () => {
              localStorage.setItem('dictationCreated', 'false');
              sessionStorage.setItem('loginMethod', 'normal');
              history.push(
                `/dashboard/jobs-list/${
                  userType === 'reviewer' ? 'jobs-to-review' : 'my-jobs'
                }/${jobStage}?fromEditor=true`
              );
            };

            if (
              loginMethod === 'crossAuth' &&
              localStorage.getItem('dictationCreated') !== 'true'
            ) {
              sessionStorage.setItem('loginMethod', 'normal');
              console.log('✅ User came from CrossAuth flow');
              getTokenForUser(accessToken)
                .then(res => {
                  if (res.data?.success && res.data.result[0]) {
                    const baseUrl = getDictationBaseUrl();
                    const encryptedCode = encodeURIComponent(
                      res.data.result[0]
                    );
                    const finalUrl = `${baseUrl}?encryptedKey=${encryptedCode}`;
                    window.location.href = finalUrl;
                  } else {
                    console.error('Failed to get encrypted code from API.');
                    redirectToJobsList();
                  }
                })
                .catch(err => {
                  console.error('Error while calling getTokenForUser:', err);
                  redirectToJobsList();
                });
            } else {
              redirectToJobsList();
            }
            notification['success']({
              message: 'Success',
              description: response.data.message
            });
          } else {
            setConfirmLoading(false);
            setCompleteTranscription(false);
            setRejectTranscription(false);
            setCompleteTranscription(false);
            setRejectTranscription(false);
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
          }
        })
        .catch(err => {
          console.log(err);
          setConfirmLoading(false);
        });

    userType === 'reviewer' &&
      completeReviewerJob(jobId, user.sessionId, sectionsData)
        .then(response => {
          if (response.data.success) {
            setJobCompleted(true);
            setConfirmLoading(false);
            history.push(
              `/dashboard/jobs-list/${
                userType === 'doctor' ? 'my-jobs' : 'jobs-to-review'
              }/${jobStage}?fromEditor=true`
            );
            notification['success']({
              message: 'Success',
              description: response.data.message
            });
          } else {
            setConfirmLoading(false);
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
          }
        })
        .catch(err => {
          console.log(err);
          setConfirmLoading(false);
        });

  };
  const reject0rAssignBack = () => {
    setConfirmLoading(true);
    let rejectComment = {
      comment: rejectNote
    };

    rejectReviewerJob(jobId, rejectComment, user.sessionId)
      .then(response => {
        if (response.data.success) {
          setConfirmLoading(false);
          history.push(
            `/dashboard/jobs-list/${
              userType === 'doctor' ? 'my-jobs' : 'jobs-to-review'
            }/${jobStage}?fromEditor=true`
          );
          notification['success']({
            message: 'Success',
            description: response.data.message
          });
        } else {
          setConfirmLoading(false);
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
        setConfirmLoading(false);
      });
    setConfirmationModal(false);
    setCompleteTranscription(false);
    setRejectTranscription(false);
  };

  const handelReleaseJob = jobId => {
    setReleaseJobId(jobId);
    setReleaseJobModalVisible(true);
  };

  const releaseJobConfirmHandler = () => {
    releaseReviewerJob(releaseJobId, user.sessionId)
      .then(response => {
        if (response.data.success) {
          notification['success']({
            message: 'Job released',
            description: response.data.message
          });
          setReleaseJobModalVisible(false);
          history.push(`/dashboard/jobs-list/available`);
        } else {
          notification['error']({
            message: 'Section Fetch Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  return loading && (editorLoading || demographicsLoading) ? (
    <Spinner />
  ) : (
    <>
      {/* <PageTitle title='Transcription Editor' /> */}
      <ContainerRow style={{ height: 'calc(100vh - 110px)', overflow: 'hidden', flexWrap: 'nowrap' }}>
        <Row justify='space-between'>
          <Col xs={14} sm={14} md={14} lg={14}>
            <TitleRow>
              <Col span={24}>
                <CustomTypography color={theme['@text-color']}>
                  {userType === 'transcriptionist'
                    ? 'Job Editor'
                    : 'Job Review'}
                </CustomTypography>
              </Col>
              <Col span={24}>
                <BreadCrumbComponent items={BreadCrumbItems} />
              </Col>
            </TitleRow>
          </Col>
          <CustomHeadingCol
            xs={4}
            sm={4}
            md={4}
            lg={3}
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            {jobStage === 'in-progress' &&
              comments.length > 0 &&
              comments.some(
                item =>
                  item !== null &&
                  item !== undefined &&
                  item.comment &&
                  item.comment.trim() !== ''
              ) && (
              <Popover
                title='Rejection Note'
                trigger='click'
                placement='bottomLeft'
                arrow={false}
                overlayStyle={{ marginTop: 8, width: 300 }} // bigger box
                content={
                  comments.length > 0 ? (
                    <div style={{ padding: '4px 0' }}>
                      {comments
                        .filter(item => item !== null && item !== undefined)
                        .map((item, idx) => (
                          <div
                            key={idx}
                            style={{
                              marginBottom: 8,
                              padding: 8,
                              background: '#f7f7f7',
                              borderRadius: 6,
                              border: '1px solid #e6e6e6'
                            }}
                          >
                            {/* <strong>{item.userType}:</strong>{' '} */}
                            {item.comment || 'No comment'}
                          </div>
                        ))}
                    </div>
                  ) : (
                    <p>No comments found</p>
                  )
                }
              >
                <InfoButton
                  type='primary'
                  shape='round'
                  icon={<MessageOutlined />}
                  style={{ fontWeight: 600 }}
                ></InfoButton>
              </Popover>
            )}

            {jobStage === 'completed' && (
              <InfoButton
                type='primary'
                shape='round'
                onClick={handlePrintNote}
              >
                Print Note
              </InfoButton>
            )}
            <Dropdown
              menu={{ items: menuItems }}
              placement='bottom'
              trigger={['click']}
            >
              <InfoButton type='primary' shape='round'>
                Patient Info
              </InfoButton>
            </Dropdown>

            {userType === 'scribe' && (
              <ActionButton
                type='primary'
                shape='round'
                onClick={handleScribeSubmit}
              >
                Close
              </ActionButton>
            )}

            <ActionButton
              type='primary'
              shape='round'
              onClick={confirmCompleteOrApprove}
              hidden={jobStage === 'in-review' || jobStage === 'completed' || user?.userType === 'scribe'}
            >
              {userType === 'doctor' ? 'Complete' : 'Approve'}
            </ActionButton>
          </CustomHeadingCol>

          {userType === 'reviewer' && (
            <>
              <CustomHeadingCol xs={4} sm={4} md={4} lg={3}>
                <ActionButton
                  shape='round'
                  reject={'true'}
                  onClick={confirmRejectorAssignBack}
                  // hidden={viewOnly}
                >
                  Reject
                </ActionButton>
              </CustomHeadingCol>

              <CustomHeadingCol xs={3} sm={3} md={3} lg={2}>
                <ActionButton
                  shape='round'
                  reject={'true'}
                  onClick={() => {
                    handelReleaseJob(jobId);
                  }}
                  hidden={userType !== 'reviewer'}
                >
                  {'Release'}
                </ActionButton>
              </CustomHeadingCol>
            </>
          )}
        </Row>

        <DividerStyle />
        <HeadingRow gutter={[12, 5]}>
          <Col span={24} style={{ marginTop: 24 }}>
            {/* 📦 Drawer with tabs inside */}
            <Drawer
              title={
                drawerType === 'details' ? 'Patient Details' : 'Face Sheet'
              }
              placement='right'
              width='60%'
              onClose={() => {
                setShowDrawer(false);
                setDrawerType(null);
              }}
              open={showDrawer}
            >
              {drawerType === 'details' && (
                <StyledTabs
                  type='card'
                  onChange={key => setOpenTab(key)}
                  items={tabList.map(tab => ({
                    label: tab.val,
                    key: tab.key,
                    children: loading ? (
                      <Spin />
                    ) : tab.val === 'Patient Details' ? (
                      <table
                        border='1'
                        cellPadding='8'
                        cellSpacing='0'
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                      >
                        <tbody>
                          {patientFieldMap.map((field, idx) => (
                            <tr key={idx}>
                              <td>
                                <strong>{field.label}</strong>
                              </td>
                              <td>{field.path}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : tab.val === 'Coverages' ? (
                      <table
                        border='1'
                        cellPadding='8'
                        cellSpacing='0'
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                      >
                        <thead>
                          <tr>
                            <th style={{ textAlign: 'left' }}>
                              Coverage Field
                            </th>
                            <th style={{ textAlign: 'left' }}>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {coverageData.map((field, idx) => (
                            <tr key={idx}>
                              <td>
                                <strong>{field.label}</strong>
                              </td>
                              <td>{field.path}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : tab.val === 'Diagnosis Info' ? (
                      <table
                        border='1'
                        cellPadding='8'
                        cellSpacing='0'
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                      >
                        <tbody>
                          {diagnosisPairs.map((pair, idx) => (
                            <tr key={idx}>
                              <td>{pair[0]}</td>
                              <td>{pair[1] || ''}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : tab.val === 'Practioners' ? (
                      <table
                        border='1'
                        cellPadding='8'
                        cellSpacing='0'
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                      >
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Relation</th>
                            <th>Address</th>
                            <th>Country</th>
                            <th>Provider Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {practionersList.map((p, index) => (
                            <tr key={index}>
                              <td>{p.name}</td>
                              <td>{p.relation}</td>
                              <td>{p.address}</td>
                              <td>{p.country}</td>
                              <td>{p.providerType}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : tab.val === 'Allergy' ? (
                      <table
                        border='1'
                        cellPadding='8'
                        cellSpacing='0'
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                      >
                        <thead>
                          <tr>
                            <th>Allergen</th>
                            <th>Allergy Intolerance ID</th>
                            <th>Category</th>
                            <th>Severity</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {allergyList.map((a, index) => (
                            <tr key={index}>
                              <td>{a.allergen}</td>
                              <td>{a.allergyIntoleranceId}</td>
                              <td>{a.category}</td>
                              <td>{a.severity}</td>
                              <td>{a.type}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : tab.val === 'Consents' ? (
                      <table
                        border='1'
                        cellPadding='8'
                        cellSpacing='0'
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                      >
                        <thead>
                          <tr>
                            <th>Consent Status</th>
                            <th>Description</th>
                            <th>Ordered By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {consentsList.map((consent, index) => (
                            <tr key={index}>
                              <td>{consent.consentStatus}</td>
                              <td>{consent.description}</td>
                              <td>{consent.orderedBy}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : tab.val === 'ADT Records' ? (
                      <table
                        border='1'
                        cellPadding='8'
                        cellSpacing='0'
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                      >
                        <thead>
                          <tr>
                            <th>Action Type</th>
                            <th>Effective Date Time</th>
                            <th>Room/Bed</th>
                            <th>Payer Code</th>
                            <th>Payer Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {advanceRows.map((row, idx) => (
                            <tr key={idx}>
                              <td>{row.actionType}</td>
                              <td>{row.effectiveDateTime}</td>
                              <td>{row.bedId}</td>
                              <td>{row.payerCode}</td>
                              <td>{row.payerName}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : tab.val === 'Contacts' ? (
                      <table
                        border='1'
                        cellPadding='8'
                        cellSpacing='0'
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                      >
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Contact Type</th>
                            <th>Relationship</th>
                            <th>Address</th>
                            <th>Phone/Email</th>
                          </tr>
                        </thead>
                        <tbody>
                          {contactRows.map((contact, index) => (
                            <tr key={index}>
                              <td>{contact.name}</td>
                              <td>{contact.types}</td>
                              <td>{contact.relationship}</td>
                              <td>{contact.address}</td>
                              <td>{contact.contactInfo}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div>No content yet</div>
                    )
                  }))}
                />
              )}

              {drawerType === 'faceSheet' && (
                <FaceSheet /> // your face sheet UI here
              )}
            </Drawer>
          </Col>
        </HeadingRow>
        <div style={{ display: 'none' }}>
          <style>{getPageMargins()}</style>
          <AuditInfoContainer ref={noteRef} className='print-section'>
            <div>
              <h3
                style={{
                  fontWeight: 'bold',
                  textAlign: 'center',
                  marginBottom: '1em'
                }}
              >
                Note Content
              </h3>

              {Array.isArray(sections) &&
                sections.map((section, index) => (
                  <div
                    key={section.id || index}
                    style={{ marginBottom: '1em' }}
                  >
                    <h3>{section.heading.customUIHeading}</h3>
                    {Array.isArray(section.content) &&
                      section.content.map((contentItem, idx) => (
                        <div
                          key={idx}
                          className='ql-editor'
                          style={{ padding: 0 }}
                          dangerouslySetInnerHTML={{
                            __html: contentItem.value
                          }}
                        />
                      ))}
                  </div>
                ))}
            </div>
          </AuditInfoContainer>
        </div>
        <ContentRow gutter={[24, 24]} style={{ flex: 1, overflow: 'hidden', flexWrap: 'nowrap' }}>
          <Col span={jobStage === 'in-progress' && (userType === 'doctor' || userType === 'scribe') ? 16 : 18} style={{ height: '100%' }}>
            <NewEditorComponent
              ref={editorRef}
              jobId={jobId}
              setCptCodes={setCptCodes}
              setCptCodesLoader={setCptCodesLoader}
              // setIgnore={setIgnore}

              deleteModalVisible={deleteModalVisible}
              setDeleteModalVisible={setDeleteModalVisible}
              cptCodesLoader={cptCodesLoader}
              setEditedSections={setEditedSections}
              setParagraphs={setParagraphs}
              demographicsData={demographicsData}
              updateEncounterDate={updateEncounterDate}
              sections={sections}
              workType={workType}
              setWorkType={setWorkType}
              dectationTemplates={dectationTemplates}
              setSections={setSections}
              headings={headings}
              inferenceActive={inferenceActive}
              setInferenceActive={setInferenceActive}
              audioRef={audioRef}
              deleteSectionHandler={deleteSectionHandler}
              deleteSectionFromEditor={deleteSectionFromEditor}
              activeSection={activeSection}
              setActiveSection={setActiveSection}
              saveStatus={saveStatus}
              printInfoData={printInfoData}
              setSaveStatus={setSaveStatus}
              setChangeStatus={setChangeStatus}
              jobName={jobName}
              loading={editorLoading}
              fetchContents={fetchContents}
              tabDataPatient={tabDataPatient}
              // inferenceAnnotation={inferenceAnnotation}
              // setInferenceAnnotation={setInferenceAnnotation}
              lastUpdateTime={lastUpdateTime}
              setLastUpdateTime={setLastUpdateTime}
              // saveTimeFormat={saveTimeFormat}
              // setEditorDataPreviewValue={setEditorDataPreviewValue}
              // setEditorData={setEditorData}
              setEditorLoading={setEditorLoading}
              formatTime={formatTime}
              activeSectionContent={activeSectionContent}
              setActiveSectionContent={setActiveSectionContent}
              viewOnly={false}
              localSectionIdMap={localSectionIdMap}
              newInferenceActive={newInferenceActive}
              setNewInferenceActive={setNewInferenceActive}
              setRefetchDemographics={setRefetchDemographics}
              refetchPatientTabData={refetchPatientTabData}
              selectionVersion={selectionVersion}
              patientDataSelection={patientDataSelection}
              patientData={patientData}
            />
          </Col>
          <Col span={jobStage === 'in-progress' && (userType === 'doctor' || userType === 'scribe') ? 8 : 6} style={{ height: '100%', overflow: 'hidden' }}>
            {jobStage === 'in-progress' && (userType === 'doctor' || userType === 'scribe') ? (
              <Demographics
                theme={theme}
                cptCodesLoader={cptCodesLoader}
                editorData={editorDataPreviewValue}
                matchedCodes={matchedCodes}
                setIgnore={setIgnore}
                setinitIgnore={setinitIgnore}
                content={inferenceActive ? inferenceData : demographicsData}
                inference={inferenceActive}
                loading={demographicsLoading}
                fetchContents={fetchContents}
                updateInferenceData={updateInferenceData}
                updateInferenceFlag={updateInferenceFlag}
                setHighlightWord={setHighlightWord}
                viewOnly={false}
                printInfoData={printInfoData}
                patientData={patientData}
                patientDataSelection={patientDataSelection}
                onSelectionSaved={(data) => {
                  setPatientDataSelection(data);
                  setSelectionVersion(v => v + 1);
                }}
              />
            ) : (
              <BillerDemographics
                sections={sections}
                matchedCodes={matchedCodes}
                setMatchedCodes={setMatchedCodes}
                theme={theme}
                editorData={editorDataPreviewValue}
                content={demographicsData}
                inference={inferenceActive}
                jobId={jobId}
                loading={demographicsLoading}
                setHighlightWord={setHighlightWord}
                highlightWord={highlightWord}
              />
            )}
          </Col>
        </ContentRow>
      </ContainerRow>

      <ConfirmationModal
        visible={
          confirmationModal ||
          (completeTranscription && userType !== 'doctor') ||
          rejectTranscription
        }
        onOk={completeTranscription ? completeOrApprove : reject0rAssignBack}
        onCancel={deleteCancelHandler}
        antdModalProps={{ centered: true, width: '300', closable: false }}
        loading={confirmLoading}
        confirmation={true}
        buttonDisabled={
          !confirmationModal && !completeTranscription && rejectNote.length <= 0
        }
      >
        {confirmationModal ? (
          <DeleteIcon />
        ) : completeTranscription ? (
          <ConfirmationIcon width={'66'} height={'66'} />
        ) : (
          <RejectIcon />
        )}

        {confirmationModal && (
          <p>Are you sure you would want to delete this section?</p>
        )}
        {completeTranscription && (
          <p>
            Are you sure you want to{' '}
            {userType === 'doctor' ? 'save' : 'approve'} this job?
          </p>
        )}
        {rejectTranscription && (
          <p>
            Are you sure you want to{' '}
            {userType === 'ROLE_DOCTOR' ? 'reject' : 'assign back'} this job?
          </p>
        )}
        {rejectTranscription && (
          <StyledTextArea
            placeholder='Enter Your Comments'
            rows={4}
            onChange={event => {
              setRejectNote(event.target.value);
            }}
          />
        )}
      </ConfirmationModal>
      <MipsCompleteModal
        visible={completeTranscription && userType === 'doctor'}
        confirmLoading={confirmLoading}
        onConfirm={completeOrApprove}
        onCancel={deleteCancelHandler}
        sections={editedSections || sections}
        mipsPrompt={mipsPrompt}
        jobId={jobId}
        userId={user?.id}
      />
      <ReleaseJobModal
        releaseJobModalVisible={releaseJobModalVisible}
        setReleaseJobModalVisible={setReleaseJobModalVisible}
        onConfirm={releaseJobConfirmHandler}
      />
      <SuccessModal
        visible={successModal}
        onOk={() => {
          setSuccessModal(false);
        }}
        antdModalProps={{ centered: true, width: '300', closable: false }}
        message='Section removed!'
      />
      <CustomSideDrawer
        title={'Session Details'}
        placement='right'
        closable={false}
        onClose={() => {
          // setSelectedSession(null);
          setDrawerVisible(false);
        }}
        visible={drawerVisible}
        width={800}
        destroyOnClose={true}
      >
        <FaceSheet />
      </CustomSideDrawer>
    </>
  );
};

export default NewEditor;
